import { render } from "./DeviceDetailsReadings.vue?vue&type=template&id=67be90fc&scoped=true"
import script from "./DeviceDetailsReadings.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsReadings.vue?vue&type=script&lang=js"

import "./DeviceDetailsReadings.vue?vue&type=style&index=0&id=67be90fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67be90fc"]])

export default __exports__